import { NavLink, useLocation } from 'react-router'
import { logoutLocally } from '@/features/auth/logout'
import { OWNER_NAV } from '@/roles/owner/nav'
import { DrawerFrame, DrawerGroup, drawerItemClass } from '@/shared/shell/DrawerFrame'
import { useLayoutStore } from '@/shared/store/layoutStore'

/** 점주 햄버거 메뉴. 점주는 데스크톱 사이드바가 없어 모든 화면 폭에서 쓴다. */
export function OwnerDrawer() {
  const setOpen = useLayoutStore((state) => state.setDrawerOpen)
  const { pathname } = useLocation()

  return (
    <DrawerFrame roleLabel="Owner / 점주" onLogout={() => logoutLocally()} desktopHidden={false}>
      {OWNER_NAV.map(({ group, items }) => (
        <DrawerGroup key={group} label={group}>
          {items.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setOpen(false)}
              className={drawerItemClass(pathname.startsWith(item.path))}
            >
              <item.icon aria-hidden className="size-5 shrink-0" />
              <span>{item.ko}</span>
            </NavLink>
          ))}
        </DrawerGroup>
      ))}
    </DrawerFrame>
  )
}
